module.exports = __webpack_public_path__ + "ui-static/img/external-detectors-no-items_dark.63e3aea6.svg";